import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetTechnicalReportsRequiredByReportGuid,
  UpdateTechnicalReportsRequiredByReportGuid,
} from "../../Redux/Reducers/ReportStage/TechnicalReportsRequired";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../Services/Account/EncryptionParams";

const TechnicalReportsRequiredPage = () => {
  const dispatch = useDispatch();
  const tokens = useParams().token;
  var token = decryptToken(tokens);
  const state = useSelector((state) => {
    return {
      TechnicalReportsRequired:
        state.TechnicalReportsRequired.TechnicalReportsRequired,
      loadingTechnicalReportsRequired:
        state.TechnicalReportsRequired.loadingTechnicalReportsRequired,
        UpdateTechnicalReportsRequired:
        state.TechnicalReportsRequired.UpdateTechnicalReportsRequired,
    };
  });
  const [list, setList] = useState();
  const getData = async () => {
    var data = await dispatch(GetTechnicalReportsRequiredByReportGuid(token));
    if (data.payload) {
      setList([...data.payload]);
    }
  };
  console.log(state.TechnicalReportsRequired, "TechnicalReportsRequired");

  useEffect(() => {
    getData();
  }, [state.UpdateTechnicalReportsRequired]);
  return true ? (
    <>
      <div className="checkbox-container">
        {list &&
          list?.map((elem, i) => {
            return (
              <>
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    // disabled={shouldDisableFields}
                    // value=""
                    checked={elem?.isActive}
                    onChange={async (e) => {
                      await dispatch(
                        UpdateTechnicalReportsRequiredByReportGuid({
                          reportId: token,
                          TableName: elem.tableName,
                          isActive: e.target.checked,
                        })
                      );
                    }}
                  />
                  {elem?.tableNameAR}
                </label>
              </>
            );
          })}
      </div>
    </>
  ) : (
    ""
  );
};

export default TechnicalReportsRequiredPage;
